export const createMarkup = value => ({ __html: value });

export const SelectStyles = {
  indicatorsContainer: () => ({
    backgroundColor: '#E6E6E6',
  }),
};

export const SelectStylesWide = {
  container: provided => ({
    ...provided,
    height: 64,
    borderColor: '#ddd',
  }),
  control: provided => ({
    ...provided,
    height: 64,
  }),
  indicatorsContainer: provided => ({
    ...provided,
    height: 62,
    backgroundColor: '#E6E6E6',
  }),
  singleValue: provided => ({
    ...provided,
    fontSize: '1.375rem',
    lineHeight: '60px',
  }),
  valueContainer: provided => ({
    ...provided,
    height: 66,
  }),
};

export const SelectBiggest = {
  container: provided => ({
    ...provided,
    height: 64,
    borderColor: '#ddd',
  }),
  control: provided => ({
    ...provided,
    height: 68,
  }),
  indicatorsContainer: provided => ({
    ...provided,
    height: 66,
    backgroundColor: '#E6E6E6',
  }),
  singleValue: provided => ({
    ...provided,
    fontSize: '1.375rem',
    lineHeight: '60px',
    height: 60,
  }),
  valueContainer: provided => ({
    ...provided,
    height: 66,
  }),
};
